<svg-icon [style.width.px]="width" [src]="'fade-stagger-circles'"></svg-icon>
